import {Outlet} from 'react-router-dom';
import Header from '../shared/ui/header/header.tsx';
import './styles/index.scss'
import styles from './App.module.scss';

function App() {
    console.log(`[App] Rendered`);
    return (
        <>
            <div className={styles.header}>
                <Header/>
            </div>
            <div className={styles.main}>
                <Outlet/>
            </div>
        </>
    );
}

export default App;